import { emitSeoTrackingEvent, OrderStatusChangeEvent } from 'nexchange-service/module/seo'
import {
    getOrderHistory,
    getOrderIndexOfOrderHistory,
    IOrderDetailsApiDto,
    mapToOrderHistoryDto,
    saveOrderHistory,
} from 'nexchange-service/module/order'
import { getUserName } from '../auth'

enum EOrderStatus {
    // Order process:
    CANCELED = 0,
    INITIAL = 11,
    PAID_UNCONFIRMED = 12,
    PAID = 13,
    PRE_RELEASE = 14,
    RELEASED = 15,
    COMPLETED = 16,

    // Refund process:
    INITIATED_REFUND = 6,
    REFUND_FAILED = 7,
    REFUNDED = 8,

    // Other:
    PENDING_KYC = 9,
    UNKNOWN = -1,
}

enum EOrderStatusName {
    // Order process:
    CANCELED = 'CANCELED',
    INITIAL = 'INITIAL',
    PAID_UNCONFIRMED = 'PAID_UNCONFIRMED',
    PAID = 'PAID',
    PRE_RELEASE = 'PRE_RELEASE',
    RELEASED = 'RELEASED',
    COMPLETED = 'COMPLETED',

    // Refund process:
    INITIATED_REFUND = 'INITIATED_REFUND',
    REFUND_FAILED = 'REFUND_FAILED',
    REFUNDED = 'REFUNDED',

    // Other:
    PENDING_KYC = 'PENDING_KYC',
    UNKNOWN = 'UNKNOWN',
}

const parseOrderStatusFromOrderDetails = (orderDetails: IOrderDetailsApiDto): EOrderStatus => {
    const orderStatusId = orderDetails?.status_name[0][0]
    return <EOrderStatus>(
        (orderStatusId in EOrderStatus ? EOrderStatus[orderStatusId] : EOrderStatus.UNKNOWN)
    )
}

const handleTrackOrderStatusChange = (orderDto: IOrderDetailsApiDto) => {
    const orderStatusId = parseOrderStatusFromOrderDetails(orderDto)

    const {
        unique_reference: orderId,
        pair: {
            base: { code: baseCode },
            quote: { code: quoteCode },
        },
        amount_eur: amountEur,
    } = orderDto

    const orderHistory = getOrderHistory()
    const orderIndexInHistory = getOrderIndexOfOrderHistory(orderId, orderHistory)
    const orderInHistory = orderHistory[orderIndexInHistory]

    const username = getUserName()

    if (!orderInHistory) {
        const { mappedOrderDto } = mapToOrderHistoryDto(orderDto, username)
        orderHistory[orderIndexInHistory] = mappedOrderDto
    }

    const isUserOrderCreator = Boolean(username) && username === orderInHistory?.userData?.username

    const {
        statusName: previousStatusName,
        userRefCode,
        referralToken,
    } = orderHistory[orderIndexInHistory] || {}

    const currentStatusName: EOrderStatusName = EOrderStatusName[orderStatusId]

    const isNewOrderStatus =
        !previousStatusName || (previousStatusName as EOrderStatusName) !== currentStatusName

    if (isNewOrderStatus) {
        emitSeoTrackingEvent(
            new OrderStatusChangeEvent({
                orderStatusName: currentStatusName,
                userDetails: {
                    username,
                },
                orderDetails: {
                    orderId,
                    pairName: `${quoteCode}-${baseCode}`,
                    amountEur,
                    userRefCode,
                    referralToken,
                    isOrderFlowPersisted: isUserOrderCreator,
                },
            }),
        )

        orderHistory[orderIndexInHistory].statusName = currentStatusName
        saveOrderHistory(orderHistory)
    }
}

export {
    EOrderStatusName,
    EOrderStatus,
    parseOrderStatusFromOrderDetails,
    handleTrackOrderStatusChange,
}
